<template src="./VerAcordeon.html"></template>
<script>
import { consultarFormulariosMomentosLlenos } from "../../apiService/request/CrudEncuentro.js";
import { serverBus } from "../../main";
import Icono from "../Icono/Icono";
export default {
  name: "ListExpansion",
  components: { Icono },
  data() {
    return {
      expandSingle: true,
      formulariosMomentosllenos: []
    };
  },
  props: {
    InformacionMomentosEncuentro: {
      type: Array,
      required: true
    }
  },
  created() {},
  methods: {
    async consultarFormulariosMomentos(momento, index) {
      console.log("entró en la consulta formulario momentos");
      this.$store.dispatch("setMomentoActualOverlay", index + 1);
      this.formulariosMomentosllenos = [];
      const respuesta = await consultarFormulariosMomentosLlenos(
        this.$store.getters.getIdVerEncuentrosOSeguimiento,
        momento
      );
      if (respuesta && respuesta.data && respuesta.data.data) {
        this.formulariosMomentosllenos = respuesta.data.data;
      }
    },
    consultarFormulariosMomentosAcordeon(formulario) {
      serverBus.$emit("verCategoriaFormularioAcordeon3", formulario);
    }
  }
};
</script>
<style lang="scss" scoped src="./VerAcordeon.scss">
</style>



// WEBPACK FOOTER //
// src/components/VerAcordeon/VerAcordeon.vue